 setTimeout(() => {
    try {
        const selector = '[name="checkout"], [href="/checkout"]';
          const position = 'beforeBegin';
          const checkoutSelector = '[name="checkout"], [href="/checkout"]';
          const targetElement = document.querySelector(selector);
          if (!targetElement || (targetElement && targetElement.parentNode && targetElement.parentNode.querySelector("#bss-b2b-net-term-button-wrapper"))) return;
          targetElement.insertAdjacentHTML(position, `<div id="bss-b2b-net-term-button-wrapper">
              <button type="button" id="bss-b2b-net-term-button">Send wholesale request</button>
          </div>`);

          BSS_B2B?.nt?.initFunction?.();
          document.dispatchEvent(new Event("DOMContentLoaded"))

          const ntBtn = document.querySelector("#bss-b2b-net-term-button");
          const closeBtn = document.querySelector(".cc-popup-close");
          if(ntBtn) {
            ntBtn.addEventListener("click", e => {
              closeBtn.click();
            })
          }
      } catch (e) {
          console.log(e)
      }
  }, 1000)